module.exports = __webpack_public_path__ + "static/media/arrow-right.f2effdf1.svg";